import { render, staticRenderFns } from "./CareerChange.vue?vue&type=template&id=4c3f2b40"
import script from "./CareerChange.vue?vue&type=script&lang=js"
export * from "./CareerChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports